import React from "react";
import { Button as MuiButton } from "@mui/material";

export default function Button(props) {
  const {
    text,
    size = "large",
    color,
    variant = "contained",
    onClick,
    ...other
  } = props;

  const colors = {
    primary: {
      bg: "rgba(244,151,3,.8)",
      text: "#fff",
      hover: "rgba(244,151,3,1)",
    },
    secondary: {
      bg: "rgb(20,61,89)",
      text: "#fff",
      hover: "rgb(20,61,89,0.8)",
    },
    default: {
      bg: "#e0e0e0",
      text: "#000",
      hover: "#bdbdbd",
    },
  };

  const selectedColor = colors[color || "primary"] || colors.default;

  return (
    <MuiButton
      variant={variant}
      size={size}
      onClick={onClick}
      {...other}
      sx={{
        margin: 0.5,
        textTransform: "none",
        whiteSpace: "nowrap",
        backgroundColor:
          variant === "contained" ? selectedColor.bg : "transparent",
        color: color === "secondary" ? "#fff" : "rgb(20,61,89)",
        borderRadius: 2,
        border:
          variant === "outlined" ? `1px solid ${selectedColor.bg}` : "none",
        boxShadow: variant === "contained" ? "none" : "none",
        "&:hover": {
          backgroundColor:
            variant === "contained" ? selectedColor.hover : "transparent",
        },
      }}
    >
      {text}
    </MuiButton>
  );
}
